import { ENABLE_NEW_RECIPE_SIMULATION } from "../../config/constants";
import RecipeSimulatorListView from "./RecipeSimulatorListView";
import RecipeSimulatorNewListView from "./RecipeSimulatorNewListView";

const RecipeSimulatorList = () => {
  return !ENABLE_NEW_RECIPE_SIMULATION ? (
    <RecipeSimulatorNewListView />
  ) : (
    <RecipeSimulatorListView />
  );
};

export default RecipeSimulatorList;
